import { CircleLoader } from '@proton/atoms';

const OfferLoader = () => (
    <div className="text-center">
        <CircleLoader size="large" className="mx-auto flex mb-8" />
    </div>
);

export default OfferLoader;
